import { Dimensions } from '@99designs/browser';
import { ZoomLevel } from '../useZoom';

export const calculateScale = (
    imageSize: Dimensions,
    viewSize: Dimensions,
    zoomLevel: ZoomLevel
) => {
    let scale;
    // eslint-disable-next-line eqeqeq
    if (zoomLevel == ZoomLevel.FLUID || zoomLevel == ZoomLevel.FIT_TO_WIDTH) {
        scale = viewSize.width / imageSize.width;
        // eslint-disable-next-line eqeqeq
    } else if (zoomLevel == ZoomLevel.FIT_TO_CONTAINER) {
        scale = Math.min(viewSize.width / imageSize.width, viewSize.height / imageSize.height);
    } else {
        scale = 1.0;
    }

    scale = Math.min(1, scale);
    return scale;
};
